import { createAction } from '@ngrx/store';

export const resetProductListStore = createAction(
  '[ProductList] Reset product list store',
);

export const resetProductListsAdapter = createAction(
  '[ProductList] Reset product lists adapter',
);
